import { ViewportScroller } from '@angular/common';
import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AnchorModel } from 'src/app/shared/models/node';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { HostListener } from '@angular/core';


@Component({
  selector: 'app-sample-anchor',
  templateUrl: './sample-anchor.component.html',
  styleUrls: ['./sample-anchor.component.scss']
})
export class SampleAnchorComponent implements OnInit, AfterViewChecked {

  @Input() anchorItems: AnchorModel[] = [];
  @Input() idAnchor: string = '';
  @Input() idAnchorCollapse: string = '';
  @Input() positionType: string = '';
  @Input() bgColor: string = '';
  @Input() color: string = '';
  @Input() positionTop: string = '';
  @Input() styleHeader: string = '';
  @Input() setOffset: number = 0;
  @Input() scrollOnTop: boolean = false;
  public positionToLeft: number = 0;
  public isEndScroll: boolean = false;
  public activeScroll: boolean = false;
  public currentAnchor: string = '';
  private scrollTimeout: any;
  private isFirstNext = true;
  public customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    animateIn: true,
    animateOut: true,
    nav: false
  };

  constructor(private scroller: ViewportScroller, private helpersService: HelpersService) { }


  ngOnInit(): void {}

  ngAfterViewChecked(): void {
    this.verifyContainer();
  }

  goTarget(target: string, idx: number) {
    this.idAnchor = target;
    this.idAnchorCollapse = target;
    if (idx === 0 && this.anchorItems.length > 1 && this.scrollOnTop) {
      this.scroller.scrollToPosition([0, 0])
    } else {
      this.scroller.scrollToAnchor(target);
      this.scroller.setOffset([0, this.setOffset]);
    }
  }

  public verifyContainer(): void {
    if (this.helpersService.isBrowser) {
      const container = document.getElementById(`container-general-anchor-${this.styleHeader}`);
      if (container) {
        if (container.scrollWidth > container.offsetWidth) {
          this.activeScroll = true;
        } else {
          this.activeScroll = false;
        }
      }
    }
  }

  public back(): void {
    const container = document.getElementById(`container-general-anchor-${this.styleHeader}`);
    if (container) {
      this.sideScroll(container, 'left', 25, 100, 10);
    }
  }
  
  public next(): void {
    const container = document.getElementById(`container-general-anchor-${this.styleHeader}`);
    if (container) {
      this.sideScroll(container, 'right', 25, 100, 10);
    }
  }
  

  private sideScroll(element: any, direction: any, speed: any, distance: any, step: any): void {
    let scrollAmount = 0;
    let slideTimer = setInterval(() => {
      if (direction == 'left') {
        element.scrollLeft -= step;
      } else {
        element.scrollLeft += step;
      }
      this.positionToLeft = element.scrollLeft;
      if (this.positionToLeft === (element.scrollWidth - element.offsetWidth)) {
        this.isEndScroll = true;
      } else {
        this.isEndScroll = false;
      }
      scrollAmount += step;
      if (scrollAmount >= distance) {
        window.clearInterval(slideTimer);
      }
    }, speed);
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event: any): void {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
    this.scrollTimeout = setTimeout(() => {
      this.updateCurrentAnchor();
    }, 100);
  }
  

  updateCurrentAnchor(): void {
    const anchors = this.anchorItems.map(item => item.idRow);
  
    let minDistance = Number.MAX_VALUE;
    let closestAnchor = '';
    let closestAnchorIndex = -1;
  
    for (const [index, anchorId] of anchors.entries()) {
      const element = document.getElementById(anchorId);
      if (element) {
        const distance = this.distanceFromTop(element);
        if (distance >= 0 && distance < minDistance) {
          minDistance = distance;
          closestAnchor = anchorId;
          closestAnchorIndex = index;
        }
      }
    }
  
    if (this.currentAnchor !== closestAnchor) {
      const currentIndex = this.anchorItems.findIndex(item => item.idRow === this.currentAnchor);
      this.currentAnchor = closestAnchor;
  
      if (closestAnchorIndex > currentIndex) {
        if (this.isFirstNext && closestAnchorIndex === 1 && currentIndex === 0) {
          this.isFirstNext = false;
          this.next();
        } else if (!this.isFirstNext) {
          this.next();
        }
      } else if (closestAnchorIndex < currentIndex) {
        this.back();
      }
    }
  }
  
  distanceFromTop(element: HTMLElement): number {
    const rect = element.getBoundingClientRect();
    return rect.top;
  }
  
}
